import AuthShell from "@/components/landing/auth/AuthShell";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function ResetPasswordBody() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  function onSubmit(event) {
    event.preventDefault();
    setError("");
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setDone(true);
  }

  return (
    <AuthShell
      className="forgot-pws"
      title="Reset password"
      subtitle="Choose a strong new password for your account."
      footer={
        done ? (
          <p className="mb-0">
            Password updated. <Link to="/login">Continue to sign in</Link>
          </p>
        ) : null
      }>
      <form onSubmit={onSubmit}>
        <div className="single-input">
          <input
            type="password"
            placeholder="New password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="single-input">
          <input
            type="password"
            placeholder="Confirm new password"
            autoComplete="new-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        {error ? <p className="text-danger small mb-3">{error}</p> : null}
        {done ? <p className="text-success small mb-3">Password reset complete.</p> : null}
        <div className="btn-area mt-0 mb-0">
          <button className="cmn-btn" type="submit">
            Update password
          </button>
        </div>
      </form>
    </AuthShell>
  );
}
